import type { SymmetryKind } from "@pdfking/filling"
import type { Distance, Margins, Rectangle } from "@pdfking/math"
import { AddMargins, Max, ToSpatial } from "@pdfking/math"

/**
 * The machine size of a job that names none: the smallest sheet one subject
 * stands on — the subject the way it comes, its padding and the job's margins.
 * A job that turns the sheet over on itself needs the subject twice: bv to the
 * right, pt down, sym along the shortest side.
 */
export const DefaultMachineSize = (
  inner: Rectangle<Distance>,
  padding: Margins<Distance>,
  margins: Margins<Distance>,
  use_symmetry: SymmetryKind
): Rectangle<Distance> => {
  const { width, height } = AddMargins(ToSpatial(inner), padding)
  const axis = use_symmetry === "both" ? (width <= height ? "x" : "y") : use_symmetry

  // A fill that stands twice keeps the same border at both ends.
  const x = Max(margins.left, margins.right) as Distance
  const y = Max(margins.top, margins.bottom) as Distance
  const security = use_symmetry ? { top: y, bottom: y, left: x, right: x } : margins

  const sheet = AddMargins(
    ToSpatial({
      width: (axis === "x" ? width * 2 : width) as Distance,
      height: (axis === "y" ? height * 2 : height) as Distance,
    }),
    security
  )
  return { width: sheet.width, height: sheet.height }
}
